import { useState, useEffect, type Dispatch, type SetStateAction } from "react";
import { getSellerNamesRefinementList } from "components/_dashboard/listingsMatch/algoliaClient";
import type { ListingOrigin } from "../@types/sharedSchema";
import { useAlgoliaIndex } from "../contexts/AlgoliaClientContext";
import { isPgSearchEnabled } from "utils/listingsSearchApi";

type SellerNames = {
  search: string;
  loading: boolean;
  sellerNames: string[];
  setSearch: Dispatch<SetStateAction<string>>;
};

export function useSellerNames(listingOrigin?: ListingOrigin): SellerNames {
  const [search, setSearch] = useState("");
  const [sellerNames, setSellerNames] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);

  const algoliaIndex = useAlgoliaIndex();

  useEffect(() => {
    // The facet comes from the server in Postgres mode, so there's no index to
    // wait for — gating on one would leave the filter permanently empty.
    if (!isPgSearchEnabled() && !algoliaIndex) return;

    const fetchSellerNames = async (): Promise<void> => {
      setLoading(true);
      try {
        const results = await getSellerNamesRefinementList(
          algoliaIndex,
          search,
          0,
          100,
          listingOrigin
        );
        setSellerNames(results);
      } catch (error) {
        console.error("Error fetching seller names:", error);
      } finally {
        setLoading(false);
      }
    };

    void fetchSellerNames();
  }, [search, algoliaIndex, listingOrigin]);

  return { sellerNames, search, loading, setSearch };
}
